"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT = exports.ICON_COLOR = exports.ICON_ID = exports.ICON_POSITION = exports.BUTTON_TARGET = exports.BUTTON_OPERATION = exports.BUTTON_FONT_FAMILY = exports.BUTTON_BORDER_RADIUS = exports.BUTTON_TYPE_HTML = exports.BUTTON_TYPE = exports.BUTTON_WIDTH = exports.BUTTON_HEIGHT = void 0;
/* eslint-disable import/extensions  */
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next12_components_icon_n_1 = __importStar(require("@gcloud-npm/next12.components.icon-n"));
Object.defineProperty(exports, "ICON_ID", { enumerable: true, get: function () { return next12_components_icon_n_1.ICON_ID; } });
Object.defineProperty(exports, "ICON_COLOR", { enumerable: true, get: function () { return next12_components_icon_n_1.ICON_COLOR; } });
const next12_components_custom_link_1 = __importDefault(require("@gcloud-npm/next12.components.custom-link"));
const next12_components_spin_1 = __importDefault(require("@gcloud-npm/next12.components.spin"));
const next12_utils_enums_segment_1 = require("@gcloud-npm/next12.utils.enums.segment");
Object.defineProperty(exports, "SEGMENT", { enumerable: true, get: function () { return next12_utils_enums_segment_1.SEGMENT; } });
const enums_js_1 = require("./enums.js");
Object.defineProperty(exports, "BUTTON_HEIGHT", { enumerable: true, get: function () { return enums_js_1.BUTTON_HEIGHT; } });
Object.defineProperty(exports, "BUTTON_WIDTH", { enumerable: true, get: function () { return enums_js_1.BUTTON_WIDTH; } });
Object.defineProperty(exports, "BUTTON_TYPE", { enumerable: true, get: function () { return enums_js_1.BUTTON_TYPE; } });
Object.defineProperty(exports, "BUTTON_TYPE_HTML", { enumerable: true, get: function () { return enums_js_1.BUTTON_TYPE_HTML; } });
Object.defineProperty(exports, "BUTTON_BORDER_RADIUS", { enumerable: true, get: function () { return enums_js_1.BUTTON_BORDER_RADIUS; } });
Object.defineProperty(exports, "BUTTON_FONT_FAMILY", { enumerable: true, get: function () { return enums_js_1.BUTTON_FONT_FAMILY; } });
Object.defineProperty(exports, "BUTTON_OPERATION", { enumerable: true, get: function () { return enums_js_1.BUTTON_OPERATION; } });
Object.defineProperty(exports, "BUTTON_TARGET", { enumerable: true, get: function () { return enums_js_1.BUTTON_TARGET; } });
Object.defineProperty(exports, "ICON_POSITION", { enumerable: true, get: function () { return enums_js_1.ICON_POSITION; } });
const Button = ({ id, buttonType, borderRadius, className, disabled, fontFamily, forceExternal, buttonWidth, height, iconProps, iconPosition, label, href, operation, segment, taggingInfo, onClick, target, buttonTypeHtml, custoObjectInfo, }) => {
    /**
     * Calcula si el botón tiene que mostrar la animación del Spin o el texto del botón
     * @returns show OR hidden OR fade
     */
    const setLabelAnimation = (operationProp) => {
        if (operationProp === enums_js_1.BUTTON_OPERATION.NO) {
            return "button-animation--no";
        }
        if (operationProp === enums_js_1.BUTTON_OPERATION.LOADING) {
            return "button-animation--loading";
        }
        if (operationProp === enums_js_1.BUTTON_OPERATION.SUCCESS) {
            return "button-animation--success";
        }
        if (operationProp === enums_js_1.BUTTON_OPERATION.FAILURE) {
            return "button-animation--failure";
        }
        return "button-animation--no";
    };
    /**
     * Calcula la clase CSS refente a la altural del botón
     * @returns normal OR small
     */
    const setHeightButtonCss = (heightProp) => {
        if (heightProp === enums_js_1.BUTTON_HEIGHT.NORMAL) {
            return "button-height--normal";
        }
        if (heightProp === enums_js_1.BUTTON_HEIGHT.SMALL) {
            return "button-height--small";
        }
        return "button-height--normal";
    };
    /**
     * Calcula la clase CSS refente aL fontFamily del botón
     * @returns normal OR small
     */
    const setFontFamilyCss = (fontFamilyProp, segment) => {
        if (fontFamilyProp === enums_js_1.BUTTON_FONT_FAMILY.BOLD) {
            return `button-fontFamily-${segment}--bold`;
        }
        if (fontFamilyProp === enums_js_1.BUTTON_FONT_FAMILY.LIGHT) {
            return `button-fontFamily-${segment}--light`;
        }
        if (fontFamilyProp === enums_js_1.BUTTON_FONT_FAMILY.REGULAR) {
            return `button-fontFamily-${segment}--regular`;
        }
        return `button-fontFamily-${segment}--regular`;
    };
    /**
     * Calcula la clase CSS refente al tema/tipo del botón
     * @returns button-type--primary or button-type--secondary or button-type--danger
     */
    const setButtonTypeCss = (buttonTypeProp, segment) => {
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.PRIMARY) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.PRIMARY}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.PRIMARY_REVERSE) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.PRIMARY_REVERSE}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.SECONDARY) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.SECONDARY}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.SECONDARY_REVERSE) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.SECONDARY_REVERSE}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.DANGER) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.DANGER}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.HEADER) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.HEADER}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.HEADER_REVERSE) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.HEADER_REVERSE}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.HEADER_PRIORITY) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.HEADER_PRIORITY}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.HEADER_PRIORITY_REVERSE) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.HEADER_PRIORITY_REVERSE}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.SELECTED) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.SELECTED}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.SELECTED_REVERSE) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.SELECTED_REVERSE}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.TAB) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.TAB}`;
        }
        if (buttonTypeProp === enums_js_1.BUTTON_TYPE.TAB_ACTIVE) {
            return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.TAB_ACTIVE}`;
        }
        return `button-type-${segment}--${enums_js_1.BUTTON_TYPE.PRIMARY}`;
    };
    /**
     * Calcula la clase CSS refente al borderRadius del botón
     * @returns button-border-radius--none OR button-border-radius--small OR button-border-radius--big_shadow
     */
    const setButtonBorderRadiusCss = (buttonBorderRadiusProp) => {
        if (buttonBorderRadiusProp === enums_js_1.BUTTON_BORDER_RADIUS.NONE) {
            return "button-border-radius--none";
        }
        if (buttonBorderRadiusProp === enums_js_1.BUTTON_BORDER_RADIUS.SMALL) {
            return "button-border-radius--small";
        }
        if (buttonBorderRadiusProp === enums_js_1.BUTTON_BORDER_RADIUS.MEDIUM) {
            return "button-border-radius--medium";
        }
        if (buttonBorderRadiusProp === enums_js_1.BUTTON_BORDER_RADIUS.BIG_SHADOW) {
            return "button-border-radius--bigWithShadow";
        }
        if (buttonBorderRadiusProp === enums_js_1.BUTTON_BORDER_RADIUS.BIG) {
            return "button-border-radius--big";
        }
        if (buttonBorderRadiusProp === enums_js_1.BUTTON_BORDER_RADIUS.FULL) {
            return "button-border-radius--full";
        }
        return "button-border-radius--small";
    };
    /**
     * Calcula la clase CSS refente a la posición que debe tomar el icono
     * @returns button-border-radius--none OR button-border-radius--small OR button-border-radius--big_shadow
     */
    const setIconPositionCss = (iconPositionProp) => {
        if (iconPositionProp === enums_js_1.ICON_POSITION.LEFT) {
            return "button-layout-icon--left";
        }
        if (iconPositionProp === enums_js_1.ICON_POSITION.RIGHT) {
            return "button-layout-icon--right";
        }
        return "";
    };
    /**
     * Calcula la clase CSS refente al width que modifica el ancho por defecto del botón.
     * @returns
     */
    const setWidthButtonCss = (buttonWidthProp) => {
        if (buttonWidthProp === enums_js_1.BUTTON_WIDTH.DEFAULT) {
            return "button-width--default";
        }
        if (buttonWidthProp === enums_js_1.BUTTON_WIDTH.FULL) {
            return "button-width--full";
        }
        return "button-width--default";
    };
    const { id: iconId } = iconProps;
    const segmentNormalized = (0, next12_utils_enums_segment_1.getCssSegment)(segment);
    const heightCss = setHeightButtonCss(height);
    const buttonTypeCss = setButtonTypeCss(buttonType, segmentNormalized);
    const borderCss = setButtonBorderRadiusCss(borderRadius);
    const labelAnimationCss = setLabelAnimation(operation);
    const fontFamilyCss = setFontFamilyCss(fontFamily, segmentNormalized);
    const buttonWidthCss = setWidthButtonCss(buttonWidth);
    let iconPositionCss = null;
    if (iconId && iconPosition) {
        iconPositionCss = setIconPositionCss(iconPosition);
    }
    const operationIsVisible = operation && operation !== enums_js_1.BUTTON_OPERATION.NO;
    const statusCss = disabled ? "buttonNew_status--disabled" : "";
    let customClassName = className ? `${className} ` : "";
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        href = "javascript:void(0)";
        customClassName = `${customClassName} custo-editable`;
    }
    if (onClick && !taggingInfo) {
        throw new Error("[Button]: taggingInfo is not present");
    }
    /* COMPLETING TAGGINGINFO IF NEEDED */
    if (onClick && taggingInfo) {
        if (!taggingInfo.componentContent) {
            // eslint-disable-next-line no-param-reassign
            taggingInfo.componentContent = label || "";
        }
        if (!taggingInfo.componentName) {
            // eslint-disable-next-line no-param-reassign
            taggingInfo.componentName = "newButton";
        }
    }
    return (react_1.default.createElement(next12_components_custom_link_1.default, { id: id || null, taggingInfo: taggingInfo, href: href, ariaLabel: label, onClick: editModal || onClick, buttonTypeHtml: buttonTypeHtml, forceExternal: forceExternal, className: `button buttonNext ${customClassName} ${fontFamilyCss} ${buttonWidthCss} ${heightCss} ${buttonTypeCss} ${borderCss} ${statusCss} ${segmentNormalized}`, target: target, disabled: disabled },
        !operationIsVisible &&
            iconId &&
            (iconPosition === enums_js_1.ICON_POSITION.RIGHT ||
                iconPosition === enums_js_1.ICON_POSITION.LEFT) && (react_1.default.createElement("div", { className: `buttonNext ${iconPositionCss}`, id: "button-textWithIcon" },
            react_1.default.createElement("span", { className: `button-textArea ${fontFamilyCss}` }, label),
            react_1.default.createElement(next12_components_icon_n_1.default, Object.assign({ id: iconId }, iconProps, { className: "button-iconArea" })))),
        !operationIsVisible && !iconId && (react_1.default.createElement("span", { id: "button-textWithoutIcon" }, label)),
        operationIsVisible && (react_1.default.createElement("div", { className: `${labelAnimationCss}`, id: "button-operation" },
            react_1.default.createElement(next12_components_spin_1.default, { operation: operation, spinType: buttonType })))));
};
Button.propTypes = {
    id: prop_types_1.default.string,
    /**
     * {
     *  "info": "Redondeado del borde",
     *  "kind": "both",
     *  "beautifulName": "Redondeado del borde"
     * }
     */
    borderRadius: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(enums_js_1.BUTTON_BORDER_RADIUS)),
    ]),
    /**
     * {
     *  "info": "Tema del botón",
     *  "kind": "both",
     *  "beautifulName": "Tema del botón",
     * }
     */
    buttonType: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(enums_js_1.BUTTON_TYPE)),
    ]),
    /**
     * {
     *  "info": "Define la clase CSS custom que se aplicará al componente",
     *  "kind": "both",
     *  "beautifulName": "Estilos custom"
     * }
     */
    className: prop_types_1.default.string,
    /**
     * {
     *  "info": "Permite definir si el botón está desactivado o no; en caso de desactivado el elemento cambiará de color y dejará de ser clicable",
     *  "kind": "both",
     *  "beautifulName": "Habilitado"
     * }
     */
    disabled: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Tipo de fuente del texto, por defecto es regular",
     *  "kind": "both",
     *  "beautifulName": "fontFamily"
     * }
     */
    fontFamily: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(enums_js_1.BUTTON_FONT_FAMILY)),
    ]),
    /**
     * {
     *  "info": "Define si el enlace se tiene que forzar a comportar como enlace externo",
     *  "kind": "playground",
     *  "beautifulName": "Enlace externo"
     * }
     */
    forceExternal: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Define el ancho del botón",
     *  "kind": "both",
     *  "beautifulName": "buttonWidth"
     * }
     */
    buttonWidth: prop_types_1.default.string,
    /**
     * {
     *  "info": "Altura del botón",
     *  "kind": "both",
     *  "beautifulName": "Altura del botón"
     * }
     */
    height: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(enums_js_1.BUTTON_HEIGHT)),
    ]),
    /**
     * {
     *  "info": "Propiedades del componente icono",
     *  "kind": "both",
     *  "beautifulName": "Propiedades del compo icono"
     * }
     */
    iconProps: prop_types_1.default.shape({
        id: prop_types_1.default.string,
        color: prop_types_1.default.oneOfType([
            prop_types_1.default.string,
            prop_types_1.default.oneOf(Object.values(next12_components_icon_n_1.ICON_COLOR)),
        ]),
        size: prop_types_1.default.number,
    }),
    /**
     * {
     *  "info": "Posicion del icono respecto al texto del botón",
     *  "kind": "both",
     *  "beautifulName": "Posición SVG"
     * }
     */
    iconPosition: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(enums_js_1.ICON_POSITION)),
    ]),
    /**
     * {
     *  "info": "Texto que aparecerá dentro del componente",
     *  "kind": "both",
     *  "beautifulName": "Texto"
     * }
     */
    label: prop_types_1.default.string,
    /**
     * {
     *  "info": "Url a la que se accederá tras hacer click en el elemento si es que lo tuviese",
     *  "kind": "both",
     *  "beautifulName": "Enlace"
     * }
     */
    href: prop_types_1.default.string,
    /**
     * {
     *  "info": "Permite establecer una animación en función de un estado a este componente, reflejando una operación de las definidas BUTTON_OPERATION",
     *  "kind": "both",
     *  "beautifulName": "Operacion"
     * }
     */
    operation: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(enums_js_1.BUTTON_OPERATION)),
    ]),
    /**
     * {
     *  "info": "Función js que se ejecutará al hacer click, si es necesario",
     *  "kind": "playground",
     *  "beautifulName": "Funcion"
     * }
     */
    onClick: prop_types_1.default.func,
    /**
     * {
     *  "info": "Valor del target en caso de tener link",
     *  "kind": "both",
     *  "beautifulName": "Target"
     * }
     */
    target: prop_types_1.default.string,
    /**
     * {
     *  "info": "Valor del tipo de button",
     *  "kind": "both",
     *  "beautifulName": "buttonTypeHtml"
     * }
     */
    buttonTypeHtml: prop_types_1.default.string,
    /**
     * {
     *  "info": "Segmento para definir carta de colores correspondiente",
     *  "kind": "both",
     *  "beautifulName": "segment"
     * }
     */
    segment: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.oneOf(Object.values(next12_utils_enums_segment_1.SEGMENT)),
    ]),
};
Button.defaultProps = {
    id: null,
    borderRadius: enums_js_1.BUTTON_BORDER_RADIUS.SMALL,
    buttonType: enums_js_1.BUTTON_TYPE.PRIMARY,
    className: "",
    disabled: false,
    fontFamily: enums_js_1.BUTTON_FONT_FAMILY.REGULAR,
    forceExternal: false,
    buttonWidth: "default",
    height: enums_js_1.BUTTON_HEIGHT.NORMAL,
    iconProps: { id: "" },
    iconPosition: enums_js_1.ICON_POSITION.RIGHT,
    label: "",
    href: "",
    operation: enums_js_1.BUTTON_OPERATION.NO,
    onClick: null,
    target: "_self",
    buttonTypeHtml: enums_js_1.BUTTON_TYPE_HTML.BUTTON,
    segment: next12_utils_enums_segment_1.SEGMENT.GP,
};
exports.default = Button;
//# sourceMappingURL=index.js.map